import React, { useState } from "react";
import "../style/Local.css";
import mapimage from "../assets/banner/map.jpg";
import LeaveMessage from "./LeaveMessage";

const Local = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* ===== Search Results Placeholder ===== */}
      <div id="searchResults"></div>
    <LeaveMessage />
   

      {/* ===== Heading ===== */}
      <section>
        <div className="heading-section">
          <h2>Local Distributor</h2>
        </div>
      </section>

      {/* ===== Distributor Section ===== */}
      <section>
        <div className="section-dis">
          <h5>
            <strong>
              We sincerely invite you to grow with us and build a better future
              together!
            </strong>
          </h5>
          <p>A-OK distributor recruitment throughout global market is in full swing. <br /><br /> A-OK export to over 180 countries and regions. And we had establish A-OK distributors in many countries , all of them have achieved great goal in the past few year, We have successfully setup  France A-OK, Spain A-OK, Vietnam A-OK, Brazil A-OK, South Korea A-OK And many more. So it is a great opportunity to join us at this moment, you can join the A-OK team to increase your sales network.  </p>
           <img src={mapimage} alt="A-OK Distributor Recruitment Banner" className="local-img"/>
          <p>
            Want to be a distributor in your local area, please feel no hesitate to contact with us.
          </p>
        </div>
      </section>
    </>
  );
};

export default Local;
